export const whiteLabelFieldRegex = {
  companyDomain: /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,11}?$/,
  companyName: /^.{1,50}$/,
  primaryColor: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
  notifBgColor: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/,
};
